'use client';

import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps", "slots", "slotProps"];

var _styled;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import Typography, { typographyClasses } from "../Typography/index.js";
import ListContext from "../List/ListContext.js";
import { styled } from "../zero-styled/index.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import listItemTextClasses, { getListItemTextUtilityClass } from "./listItemTextClasses.js";
import useSlot from "../utils/useSlot.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
      inset = ownerState.inset,
      primary = ownerState.primary,
      secondary = ownerState.secondary,
      dense = ownerState.dense;
  var slots = {
    root: ['root', inset && 'inset', dense && 'dense', primary && secondary && 'multiline'],
    primary: ['primary'],
    secondary: ['secondary']
  };
  return composeClasses(slots, getListItemTextUtilityClass, classes);
};

var ListItemTextRoot = styled('div', {
  name: 'MuiListItemText',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [_defineProperty({}, "& .".concat(listItemTextClasses.primary), styles.primary), _defineProperty({}, "& .".concat(listItemTextClasses.secondary), styles.secondary), styles.root, ownerState.inset && styles.inset, ownerState.primary && ownerState.secondary && styles.multiline, ownerState.dense && styles.dense];
  }
})((_styled = {
  flex: '1 1 auto',
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, _defineProperty(_styled, ".".concat(typographyClasses.root, ":where(& .").concat(listItemTextClasses.primary, ")"), {
  display: 'block'
}), _defineProperty(_styled, ".".concat(typographyClasses.root, ":where(& .").concat(listItemTextClasses.secondary, ")"), {
  display: 'block'
}), _defineProperty(_styled, "variants", [{
  props: function props(_ref3) {
    var ownerState = _ref3.ownerState;
    return ownerState.primary && ownerState.secondary;
  },
  style: {
    marginTop: 6,
    marginBottom: 6
  }
}, {
  props: function props(_ref4) {
    var ownerState = _ref4.ownerState;
    return ownerState.inset;
  },
  style: {
    paddingLeft: 56
  }
}]), _styled));
var ListItemText = /*#__PURE__*/React.forwardRef(function ListItemText(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiListItemText'
  });

  var children = props.children,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      _props$slots = props.slots,
      slots = _props$slots === void 0 ? {} : _props$slots,
      _props$slotProps = props.slotProps,
      slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
      other = _objectWithoutProperties(props, _excluded);

  var _React$useContext = React.useContext(ListContext),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;
  var secondary = secondaryProp;

  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    disableTypography: disableTypography,
    inset: inset,
    primary: !!primary,
    secondary: !!secondary,
    dense: dense
  });

  var classes = useUtilityClasses(ownerState);
  var externalForwardedProps = {
    slots: slots,
    slotProps: _objectSpread({
      primary: primaryTypographyProps,
      secondary: secondaryTypographyProps
    }, slotProps)
  };

  var _useSlot = useSlot('primary', {
    className: classes.primary,
    elementType: Typography,
    externalForwardedProps: externalForwardedProps,
    ownerState: ownerState
  }),
      _useSlot2 = _slicedToArray(_useSlot, 2),
      PrimarySlot = _useSlot2[0],
      primarySlotProps = _useSlot2[1];

  var _useSlot3 = useSlot('secondary', {
    className: classes.secondary,
    elementType: Typography,
    externalForwardedProps: externalForwardedProps,
    ownerState: ownerState
  }),
      _useSlot4 = _slicedToArray(_useSlot3, 2),
      SecondarySlot = _useSlot4[0],
      secondarySlotProps = _useSlot4[1];

  if (primary != null && primary.type !== Typography && !disableTypography) {
    primary = /*#__PURE__*/_jsx(PrimarySlot, _objectSpread(_objectSpread({
      variant: dense ? 'body2' : 'body1',
      component: primarySlotProps !== null && primarySlotProps !== void 0 && primarySlotProps.variant ? undefined : 'span'
    }, primarySlotProps), {}, {
      children: primary
    }));
  }

  if (secondary != null && secondary.type !== Typography && !disableTypography) {
    secondary = /*#__PURE__*/_jsx(SecondarySlot, _objectSpread(_objectSpread({
      variant: "body2",
      color: "textSecondary"
    }, secondarySlotProps), {}, {
      children: secondary
    }));
  }

  return /*#__PURE__*/_jsxs(ListItemTextRoot, _objectSpread(_objectSpread({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other), {}, {
    children: [primary, secondary]
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default ListItemText;